import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
  },
}));

export default useStyles;
